// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2020project/2020dreamsong/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getNews = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};

const addView = () => {
  return http.get(`${urlPrefix}view`);
};

const getRules = (id: number) => {
  const data: { [key: number]: string } = {
    1: `<p>为深入贯彻习近平新时代中国特色社会主义思想和党的二十届三中全会精神，全面落实习近平总书记视察重庆重要讲话重要指示精神，牢牢把握高质量发展这个首要任务，锚定建设国家重要先进制造业中心目标，加快推进新型工业化，因地制宜发展新质生产力，梯度培育优质中小企业，不断壮大“33618”现代制造业集群，加快构建以先进制造业为骨干的现代化产业体系。</p>
    <p>根据《重庆市制造业领军（链主）企业跨越发展“鲲鹏”行动计划（2024—2027年）》《重庆市推进“专精特新”企业高质量发展专项行动计划（2022—2025年）》等精神，为千方百计激发企业家创新创业活力，推动企业发挥更大作用实现更大发展，特策划开展寻访“重庆市制造业十大影响力年度人物暨专精特新中小企业优秀企业家”主题活动，弘扬制造业榜样力量，营造适宜企业家成长、弘扬企业家精神的良好生态，助力产业向“新”而行，为现代化新重庆建设作出新的更大贡献。</p>`,
    2: `<h4>（一）指导单位</h4>
<p>重庆市经济和信息化委员会</p>
<h4>（二）主办单位</h4>
<p>重庆日报报业集团</p>
<h4>（三）承办单位</h4>
<p>上游新闻</p>`,
    3: `<p style='text-indent: 0'>（一）“2024重庆市制造业十大影响力年度人物”主题活动</p><p style='text-indent: 0'>（二）“2024专精特新中小企业优秀企业家”主题活动</p>`,
    4: `<p>参与对象为个人，主要面向制造业领域（含软件信息服务业），重点聚焦制造业领军、链主、链核、链创企业（机构）、“双百企业”、专精特新中小企业、专精特新“小巨人”企业、单项冠军企业等主要经营管理负责人、高级经营管理人才、高级技术人才以及具有突出贡献的创新人才等。</p>`,
    5: `<p>参与对象为个人，主要面向制造业领域（含软件信息服务业），重点聚焦制造业领军、链主、链核、链创企业（机构）、“双百企业”、专精特新中小企业、专精特新“小巨人”企业、单项冠军企业等主要经营管理负责人、高级经营管理人才、高级技术人才以及具有突出贡献的创新人才等。</p>
    <h4>（一）基本条件</h4>
    <p>1.坚持正确政治方向，热爱祖国，自觉践行社会主义核心价值观。</p>
    <p>2.遵守宪法和法律。</p>
    <p>3.具有良好的职业道德，诚实守信，爱岗敬业，学风严谨，为人正派，在制造业（行业）具有良好声誉。</p>
    <p>4.本人及所在单位近三年未发生重大、特大安全生产事故，重大、特大环境事故，未发生造成恶劣影响的社会稳定事件和严重违规违法行为。</p>
    <h4>（二）具体条件</h4>
    <h5>1.“2024重庆市制造业十大影响力年度人物”宣传对象</h5>
    <p>（1）参与人员于2024年度在同一单位担任董事长、总裁或总经理等主要领导职务。</p>
    <p>（2）参与人员须在2024年度对推动重庆市制造业高质量发展作出重大贡献，具有一定的社会影响力。且至少符合下列条件之一：</p>
    <p>引领行业发展。所经营管理的企业发挥较强的行业推动及引领作用，以新质生产力赋能发展，在技术成果、创新产品、平台建设、行业改革等方面实现核心突破，对重庆市制造业优化升级和提振发展起到积极支撑和推动作用。</p>
    <p>经济表现强劲。所经营管理的企业在行业细分领域拥有较好的市场地位，在上规模、增效益、带动上下游企业发展等方面拥有较为强劲的经济表现。</p>
    <p>培养优秀人才。重视引进和培养人才，在创新人才培养体制机制、多渠道帮助青年人才成长、改革推进富有成效薪酬激励机制等方面有创新性措施，极大地调动人才队伍干事创业激情。</p>
    <p>公众影响深远。具有较为深远的公众影响力、知名度、诚信度，能够通过个人领导力带动制造业行业、企业、团队等方面的发展，积极关注并支持社会公益事业建设。</p>
    <h5>2.“2024专精特新中小企业优秀企业家”宣传对象</h5>
    <p>（1）参与人员为重庆市市级专精特新中小企业或国家专精特新“小巨人”企业法定代表人、公司董事长、执行董事或总经理，在参与企业从业3年及以上。</p>
    <p>（2）所经营管理的企业2024年度营业收入须为正增长，主导产品在细分市场中具备较强竞争力，在产业界及社会各界具有一定影响。</p>
    <p>（3）所经营管理的企业创新性较强，成长性较好，其创新理念和经验在行业取得一定影响或得到推广和传播。</p>
    <p>（4）参与人员具备较为先进的经营管理理念及科学发展观，企业发展力较强。</p>
    <p>（5）所经营管理企业在企业纳税、吸纳就业、参与公益事业等情况表现良好，为行业及区域经济发展贡献较好。</p>`,
    6: `<p>本次主题活动分为推荐参与和自主参与两种方式。</p>
    <p>（一）推荐报名</p>
    <p>1.由各区县（开发区）经信部门推荐符合条件的企业家参与，每家企业只能推荐1人作为宣传对象。</p>
    <p>2.参与企业家根据参与内容填写电子报名表（见“报名通道”），并同步将基础报名情况报送至推荐单位<span>【各区县（开发区）经信部门】</span>。</p>
    <p>推荐单位汇总报名信息后填写汇总表<a href='https://image2.cqcb.com/d/file/topics/activity/2024-12-23/kuCOmHsf-1734945012464.doc'>（报名汇总表）</a>，并于2025年2月14日17:00前发至邮箱zzyrw2024@163.com【邮件主题标注为“推荐单位”，推荐多家企业的，请一次性发送】。</p>
    <p>（二）自主报名</p>
    <p>参与企业家根据参与类别直接填写电子报名表（见“报名通道”）。</p>`,
  };
  return data[id];
};

export { getBaseInfo, getRules, addView, getNews  };
